(function () {
  'use strict';

  const ARABIC_REGEX = /[\u0600-\u06FF\u0750-\u077F\u0870-\u089F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/;
  const HEADING_TAGS = 'h1,h2,h3,h4,h5,h6,.h0,.h1,.h2,.h3,.h4,.h5,.h6';
  const IGNORED = 'script,style,noscript,template,svg,symbol,path,iframe';

  const pending = new Set();
  let frame = 0;

  function containsArabic(text) {
    return ARABIC_REGEX.test(text || '');
  }

  function ignored(element) {
    return !element || Boolean(element.closest(IGNORED));
  }

  function isHeadingLike(element) {
    if (!element) return false;
    if (element.matches(HEADING_TAGS)) return true;

    const cls = String(element.className || '');
    return /(^|\s|[-_])(heading|title)(\s|$|[-_])/i.test(cls);
  }

  function applyToElement(element) {
    if (!(element instanceof Element) || ignored(element)) return;

    const ownText = Array.from(element.childNodes)
      .filter((node) => node.nodeType === Node.TEXT_NODE)
      .map((node) => node.nodeValue || '')
      .join(' ');

    const hasArabic = containsArabic(ownText);

    if (!hasArabic) {
      element.classList.remove('arabic-text', 'arabic-heading');
      return;
    }

    const heading = isHeadingLike(element) ? element : element.closest(HEADING_TAGS);

    if (heading) {
      element.classList.remove('arabic-text');
      element.classList.add('arabic-heading');
      heading.classList.remove('arabic-text');
      heading.classList.add('arabic-heading');
    } else {
      element.classList.remove('arabic-heading');
      element.classList.add('arabic-text');
    }
  }

  function scan(root) {
    if (!root) return;

    if (root.nodeType === Node.TEXT_NODE) {
      if (root.parentElement) applyToElement(root.parentElement);
      return;
    }

    if (!(root instanceof Element) || ignored(root)) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        if (!node.nodeValue || !containsArabic(node.nodeValue)) return NodeFilter.FILTER_REJECT;
        const parent = node.parentElement;
        if (!parent || ignored(parent)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    const parents = new Set();
    while (walker.nextNode()) {
      if (walker.currentNode.parentElement) parents.add(walker.currentNode.parentElement);
    }
    parents.forEach(applyToElement);
  }

  function queue(node) {
    if (!node) return;
    pending.add(node);
    if (frame) return;

    frame = requestAnimationFrame(function () {
      frame = 0;
      const nodes = Array.from(pending);
      pending.clear();
      nodes.forEach(scan);
    });
  }

  function init() {
    if (!document.body) return;
    scan(document.body);

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData') {
          queue(mutation.target);
          return;
        }

        mutation.addedNodes.forEach(queue);
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    queue(event.target);
  });
})();
